export type PermissionTemplateFilterParametersProps = {
  name?: string;
};

/**
 * The filter `GET permissions/templates` takes (`PermissionTemplateFilterParameters` in the
 * Permissions API). Templates are not grants, so they have their own contract rather than
 * borrowing the grant filter and sending it fields the endpoint does not read.
 */
export default class PermissionTemplateFilterParameters {
  /** Matched case-insensitively anywhere in the template's name. */
  public readonly name?: string;

  public get searchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.name) searchParams.append("name", this.name);
    return searchParams;
  }

  public constructor(props: PermissionTemplateFilterParametersProps) {
    const name = props.name?.trim();
    this.name = name || undefined;
  }

  public isEqualTo(other: PermissionTemplateFilterParameters | undefined): boolean {
    if (!other) return false;
    return this.name === other.name;
  }

  public toString(): string {
    return this.searchParams.toString();
  }
}
